// removed by extract-text-webpack-plugin
module.exports = {"lightPurple":"#e2c0f9","purple":"#9800ff","small":"(min-width:600px)","medium":"(min-width:768px)","medium-large":"(min-width:1024px)","large":"(min-width:1200px)","extra-large":"(min-width:1400px)","sans":"fonts__sans___1IZhO","nav":"workNav__nav___2vnXn","list":"workNav__list___3zPQS","listItem":"workNav__listItem___EFEmD fonts__sans___1IZhO","isActive":"workNav__isActive___2-Cv-"};


//////////////////
// WEBPACK FOOTER
// ./src/components/WorkNav/workNav.css
// module id = 170
// module chunks = 0